import "./chunk-2L3ZO4UM.mjs";

// chains/chains.ts
import { mainnet, goerli } from "wagmi/chains";
var avalandche = {
  id: 43114,
  name: "Avalanche C-Chain",
  network: "avalanche",
  rpcUrls: {
    default: "https://rpc.ankr.com/avalanche"
  },
  nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
  blockExplorers: {
    default: {
      name: "snowtrace",
      url: "https://snowtrace.io/"
    }
  }
};
var mainnetz = {
  id: 2016,
  name: "Mainnetz Network",
  network: "Mainnetz",
  rpcUrls: {
    default: "https://mainnet-rpc.mainnetz.io"
  },
  nativeCurrency: { name: "Mainnetz", symbol: "NETZ", decimals: 18 },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://netzexplorer.io/"
    }
  },
  multicall: {
    address: "0xa6142FC56751377fFb0798f2e5f535b99FA05184",
    blockCreated: 17422483
  }
};
var base = {
  id: 8453,
  name: "Base Mainnet",
  network: "Base",
  rpcUrls: {
    default: "https://mainnet.base.org"
  },
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://basescan.org"
    }
  }
};
var mainnetzTestnet = {
  id: 9768,
  name: "Mainnetz Test Network",
  network: "Mainnetz Testnet",
  rpcUrls: {
    default: "https://testnet-rpc.mainnetz.io"
  },
  nativeCurrency: { name: "Mainnetz", symbol: "tNETZ", decimals: 18 },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.mainnetz.io/"
    }
  }
};
var avalandcheFuji = {
  id: 43113,
  name: "Avalanche Fuji",
  network: "avalanche-fuji",
  rpcUrls: {
    default: "https://rpc.ankr.com/avalanche_fuji"
  },
  nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
  blockExplorers: {
    default: {
      name: "snowtrace",
      url: "https://testnet.snowtrace.io/"
    }
  },
  testnet: true
};
var fantomOpera = {
  id: 250,
  name: "Fantom Opera",
  network: "fantom",
  nativeCurrency: { name: "Fantom", symbol: "FTM", decimals: 18 },
  rpcUrls: {
    default: "https://rpc.ftm.tools"
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://ftmscan.com"
    }
  }
};
var fantomTestnet = {
  id: 4002,
  name: "Fantom Testnet",
  network: "fantom-testnet",
  nativeCurrency: { name: "Fantom", symbol: "FTM", decimals: 18 },
  rpcUrls: {
    default: "https://rpc.testnet.fantom.network"
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://testnet.ftmscan.com"
    }
  },
  testnet: true
};
var bscExplorer = { name: "BscScan", url: "https://bscscan.com" };
var bsc = {
  id: 56,
  name: "BNB Smart Chain",
  network: "bsc",
  rpcUrls: {
    public: "https://bsc-dataseed.binance.org",
    default: "https://bsc-dataseed.binance.org"
  },
  blockExplorers: {
    default: bscExplorer,
    etherscan: bscExplorer
  },
  nativeCurrency: {
    name: "Binance Chain Native Token",
    symbol: "BNB",
    decimals: 18
  },
  multicall: {
    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
    blockCreated: 15921452
  }
};
var bscTest = {
  id: 97,
  name: "BNB Smart Chain Testnet",
  network: "bsc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Binance Chain Native Token",
    symbol: "tBNB"
  },
  rpcUrls: {
    public: "https://bsc-testnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5",
    default: "https://bsc-testnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5"
  },
  blockExplorers: {
    default: { name: "BscScan", url: "https://testnet.bscscan.com" }
  },
  multicall: {
    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
    blockCreated: 17422483
  },
  testnet: true
};
export {
  avalandche,
  avalandcheFuji,
  base,
  bsc,
  bscTest,
  fantomOpera,
  fantomTestnet,
  goerli,
  mainnet,
  mainnetz,
  mainnetzTestnet
};
